module.exports = __webpack_public_path__ + "abe9079819f6c968a1bca7af54c53985.svg";